import { render, staticRenderFns } from "./TagsByOccurrence.vue?vue&type=template&id=a0c875b6&"
import script from "./TagsByOccurrence.vue?vue&type=script&lang=js&"
export * from "./TagsByOccurrence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports